import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import MUIButton from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import React, { FC, useState } from "react";

import Button from "../../../components/elements/Button";
import classes from "./CampaignSummarySlide.module.scss";
import successIcon from "../../../assets/icons/SuccessIcon.svg";

type SuccessDialogProps = {
  pixelEventId: number | null;
  isOpen: boolean;
  handleClose: () => void;
};

const SuccessDialog: FC<SuccessDialogProps> = ({ pixelEventId, isOpen, handleClose }) => {
  const [isCopied, setIsCopied] = useState(false);
  const trackingPixel = `<code>
  &lt;!--BEGIN CONVERSION TAG, DO NOT REMOVE --&gt; &lt;script&gt; var cachebuster =
  Math.floor(Math.random() * 10000000000); var img = new Image(); img.width = 0; img.height = 0; img.src
  = 'https://cnv.event.prod.bidr.io./log/cnv?tag_id=${pixelEventId}
  &buzz_key=brandgen&value=[VALUE]&segment_key=${pixelEventId}
  &order=[ORDER]&ord=' + cachebuster; document.body.appendChild(img); //can be modified to
  wherever you want the image added/appended &lt;/script&gt; &lt;!--END CONVERSION TAG, DO NOT REMOVE
  --&gt;
</code>`;

  const handleCopy = () => {
    navigator.clipboard.writeText(trackingPixel);
    setIsCopied(true);
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} aria-labelledby="dialog-title" aria-describedby="dialog-description">
      <DialogTitle>Campaign was created successfully!</DialogTitle>
      <DialogContent>
        <img className={classes.successIcon} src={successIcon} alt="Success icon" />
        <DialogContentText>{trackingPixel}</DialogContentText>

        <div className={classes.copyTrackingPixelBtnContainer}>
          <Button disabled={isCopied} onClick={handleCopy} className={classes.copyTrackingPixelBtn}>
            Copy Conversion Pixel
          </Button>
          {isCopied ? <Typography className={classes.helperText}>Copied to clikboard!</Typography> : null}
        </div>
      </DialogContent>
      <DialogActions>
        <MUIButton onClick={handleClose} color="primary">
          Finish
        </MUIButton>
      </DialogActions>
    </Dialog>
  );
};

export default SuccessDialog;
